var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRmaFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_466:11178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#D05437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8609 62.1877C59.2333 62.187 58.7244 61.6888 58.7251 61.0744L58.7293 55.1075C58.73 54.4931 59.2389 53.9956 59.8665 53.9956C60.494 53.9963 61.0029 54.4945 61.0022 55.1096L60.998 61.0758C60.998 61.6902 60.4884 62.1884 59.8609 62.1877Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0721 56.0781C48.7586 55.5457 48.945 54.865 49.4888 54.5581L54.7691 51.5784C55.3129 51.2716 56.0081 51.4548 56.3216 51.9871C56.635 52.5195 56.4479 53.1995 55.9041 53.5064L50.6246 56.4861C50.0808 56.7929 49.3855 56.6104 49.0721 56.0781Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0801 43.8947C49.3942 43.363 50.0895 43.1812 50.6326 43.4887L55.9086 46.4753C56.4525 46.7828 56.6381 47.4635 56.324 47.9952C56.0092 48.5276 55.3146 48.7093 54.7708 48.4018L49.4947 45.4146C48.9516 45.1071 48.7659 44.4264 49.0801 43.8947Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8738 37.785C60.5013 37.7857 61.0102 38.2839 61.0095 38.8983L61.0054 44.8652C61.0047 45.4796 60.4958 45.9772 59.8682 45.9772C59.2406 45.9765 58.7317 45.4783 58.7324 44.8632L58.7366 38.897C58.7366 38.2826 59.2462 37.7844 59.8738 37.785Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6617 43.896C70.9752 44.4284 70.7888 45.1091 70.245 45.416L64.9647 48.3957C64.4209 48.7025 63.7256 48.5194 63.4122 47.987C63.0988 47.4546 63.2859 46.7746 63.8297 46.4677L69.1092 43.488C69.653 43.1812 70.3483 43.3637 70.6617 43.896Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.657 56.1158C70.3429 56.6475 69.6476 56.8293 69.1045 56.5218L63.8284 53.5352C63.2846 53.2277 63.0989 52.547 63.413 52.0153C63.7279 51.4829 64.4225 51.3012 64.9663 51.6087L70.2423 54.5959C70.7854 54.9034 70.9711 55.5841 70.657 56.1158Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2472 61.9364C66.7069 62.2488 66.0095 62.0731 65.6912 61.5435L63.5118 57.9842C63.1928 57.4553 63.3729 56.7732 63.9132 56.4609C64.4542 56.1486 65.1509 56.3242 65.4699 56.8539L67.6486 60.4131C67.9676 60.9421 67.7875 61.6241 67.2472 61.9364Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0465 62.1287C52.4999 61.8266 52.3073 61.1479 52.6158 60.6128L54.6751 56.9859C54.9837 56.4508 55.6769 56.2622 56.2235 56.5643C56.7701 56.8663 56.9627 57.545 56.6542 58.0801L54.5949 61.707C54.2863 62.2421 53.5931 62.4307 53.0465 62.1287Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8028 50.1679C45.7972 49.5535 46.3005 49.0505 46.9288 49.045L51.1661 48.9774C51.7944 48.9712 52.3075 49.4646 52.3137 50.079C52.3193 50.6934 51.8153 51.1964 51.1877 51.2019L46.9497 51.2702C46.3221 51.2757 45.8084 50.7823 45.8028 50.1679Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7545 38.0521C53.2948 37.7398 53.9922 37.9154 54.3105 38.4451L56.4899 42.0043C56.8089 42.5333 56.6288 43.2153 56.0885 43.5276C55.5475 43.84 54.8508 43.6643 54.5318 43.1347L52.3531 39.5754C52.0341 39.0465 52.2142 38.3644 52.7545 38.0521Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.95 37.8732C67.4966 38.1753 67.6893 38.8539 67.3808 39.3891L65.3214 43.0159C65.0129 43.5511 64.3197 43.7397 63.7731 43.4376C63.2265 43.1355 63.0338 42.4569 63.3424 41.9218L65.4017 38.2949C65.7103 37.7598 66.4035 37.5712 66.95 37.8732Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1985 49.8251C74.2041 50.4394 73.7008 50.9424 73.0725 50.9479L68.8352 51.0156C68.2069 51.0217 67.6938 50.5283 67.6875 49.9139C67.682 49.2995 68.186 48.7965 68.8135 48.791L73.0516 48.7227C73.6791 48.7172 74.1929 49.2107 74.1985 49.8251Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8085 73.52C59.1809 73.5186 58.6734 73.0191 58.6748 72.4047L58.6895 66.4384C58.6909 65.824 59.2005 65.3265 59.828 65.3279C60.4563 65.3299 60.9638 65.8288 60.9624 66.4432L60.9477 72.4101C60.9463 73.0245 60.4361 73.5214 59.8085 73.52Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0287 61.707C38.716 61.1739 38.9038 60.4939 39.4483 60.1877L44.7334 57.2169C45.2779 56.9107 45.9725 57.0953 46.2852 57.6276C46.5979 58.1607 46.4095 58.8407 45.8657 59.1469L40.5805 62.1177C40.036 62.4239 39.3414 62.24 39.0287 61.707Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0814 38.1707C39.3962 37.639 40.0922 37.4585 40.6346 37.7668L45.9058 40.7629C46.4482 41.0711 46.6332 41.7518 46.3177 42.2835C46.0028 42.8152 45.3075 42.9956 44.7644 42.6874L39.494 39.6913C38.9509 39.3831 38.7666 38.7024 39.0814 38.1707Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9225 26.48C60.55 26.4814 61.0575 26.9809 61.0562 27.5953L61.0415 33.5615C61.0401 34.1759 60.5305 34.6735 59.9029 34.6721C59.2747 34.6701 58.7672 34.1712 58.7686 33.5568L58.7832 27.5899C58.7846 26.9755 59.2949 26.4786 59.9225 26.48Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7108 38.2881C81.0236 38.8211 80.8358 39.5011 80.2913 39.8073L75.0062 42.7781C74.4617 43.0843 73.7671 42.8998 73.4543 42.3674C73.1416 41.8343 73.3301 41.1543 73.8739 40.8482L79.159 37.8773C79.7035 37.5712 80.3981 37.755 80.7108 38.2881Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6505 61.792C80.3357 62.3237 79.6397 62.5041 79.0973 62.1959L73.8261 59.1998C73.2837 58.8916 73.0987 58.2109 73.4143 57.6792C73.7291 57.1475 74.4244 56.9671 74.9675 57.2753L80.238 60.2714C80.7811 60.5796 80.9653 61.2603 80.6505 61.792Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1242 71.9711C67.5336 72.1802 66.8823 71.8809 66.6687 71.3034L64.5954 65.6925C64.3818 65.115 64.6876 64.4767 65.2775 64.2676C65.868 64.0585 66.5193 64.3578 66.7329 64.9353L68.8062 70.5462C69.0198 71.1243 68.7148 71.762 68.1242 71.9711Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6161 67.879C44.1359 67.4833 44.0751 66.7814 44.4793 66.3112L48.406 61.748C48.8102 61.2778 49.5271 61.2184 50.0074 61.6141C50.487 62.0098 50.5484 62.7116 50.1442 63.1818L46.2175 67.745C45.8133 68.2145 45.0964 68.2747 44.6161 67.879Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4978 45.8906C36.6081 45.2857 37.198 44.8825 37.8165 44.9905L43.8158 46.0382C44.4343 46.1462 44.8454 46.7237 44.7351 47.3292C44.6249 47.934 44.035 48.3365 43.4172 48.2285L37.4172 47.1815C36.7994 47.0736 36.3875 46.4954 36.4978 45.8906Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8806 28.0122C52.4711 27.8031 53.1224 28.1024 53.3361 28.6799L55.4093 34.2908C55.623 34.8683 55.3172 35.5066 54.7273 35.7157C54.1367 35.9248 53.4854 35.6255 53.2718 35.048L51.1985 29.4371C50.9849 28.859 51.29 28.2213 51.8806 28.0122Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3836 32.1262C75.8639 32.5219 75.9246 33.2237 75.5204 33.6939L71.5937 38.2571C71.1896 38.7273 70.4726 38.7868 69.9924 38.3911C69.5128 37.9954 69.4514 37.2935 69.8555 36.8233L73.7822 32.2601C74.1864 31.7906 74.9033 31.7305 75.3836 32.1262Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5023 54.0957C83.392 54.7005 82.8021 55.1038 82.1836 54.9958L76.1843 53.9481C75.5658 53.8401 75.1547 53.2626 75.265 52.6571C75.3753 52.0523 75.9651 51.6498 76.5829 51.7577L82.5829 52.8047C83.2007 52.9127 83.6126 53.4909 83.5023 54.0957Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7651 67.3299C75.2967 67.7386 74.5777 67.6983 74.1603 67.2391L70.1065 62.7839C69.6891 62.3253 69.731 61.6214 70.1994 61.2127C70.6685 60.804 71.3868 60.845 71.8043 61.3036L75.858 65.7588C76.2754 66.218 76.2336 66.9213 75.7651 67.3299Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5577 72.0347C51.9615 71.842 51.6383 71.2125 51.8359 70.6289L53.75 64.9641C53.9468 64.3811 54.5898 64.0647 55.1859 64.2574C55.7821 64.4508 56.1053 65.0802 55.9077 65.6632L53.9936 71.328C53.7968 71.911 53.1538 72.2274 52.5577 72.0347Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7845 54.6827C36.6575 54.0813 37.0526 53.4922 37.6669 53.3678L43.6354 52.1581C44.2497 52.0338 44.8515 52.4206 44.9785 53.0227C45.1056 53.6241 44.7105 54.2132 44.0955 54.3376L38.1276 55.5465C37.5133 55.6716 36.9116 55.2841 36.7845 54.6827Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2326 32.653C44.701 32.2443 45.42 32.2846 45.8375 32.7439L49.8912 37.1991C50.3086 37.6576 50.2668 38.3616 49.7984 38.7702C49.3292 39.1789 48.6109 39.1379 48.1935 38.6794L44.1397 34.2242C43.7223 33.7649 43.7642 33.0617 44.2326 32.653Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4462 27.9738C68.0423 28.1666 68.3655 28.796 68.168 29.3796L66.2539 35.0445C66.057 35.6274 65.4141 35.9438 64.8179 35.7511C64.2218 35.5577 63.8986 34.9283 64.0961 34.3453L66.0102 28.6805C66.2071 28.0975 66.85 27.7811 67.4462 27.9738Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2129 45.2962C83.34 45.8976 82.9448 46.4867 82.3305 46.6111L76.362 47.8208C75.7477 47.9452 75.1459 47.5583 75.0189 46.9563C74.8918 46.3548 75.2869 45.7657 75.9019 45.6414L81.8698 44.4324C82.4841 44.3073 83.0859 44.6948 83.2129 45.2962Z",
    stroke: "#373433",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 11.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_466:11178",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.815686 0 0 0 0 0.329412 0 0 0 0 0.215686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_466:11178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_466:11178",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmaFilled);
export default __webpack_public_path__ + "static/media/rma_filled.25d1792e.svg";
export { ForwardRef as ReactComponent };